/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "游戏商品ID", -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "200px"
  }
}, " 游戏商品ID由CP提供，商品ID唯一不能重复，保存后将无法修改（删除后也无法继续使用，请谨慎操作） ", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "商品名称", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "200px"
  }
}, " 游戏商品ID对应的商品名称，方便内部商品区分查看 ", -1);
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGoodsList, apiUsdkDelGoods, apiUsdkUpdateGoods, apiUsdkGetCurrencyList } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'goodsConf',
  props: {
    active: {
      type: String,
      default: 'goodsConf'
    },
    height: {
      type: Number
    }
  },
  emits: ['onActive'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const columns = [{
      label: '游戏商品ID',
      prop: 'goods',
      header: 'goods'
    }, {
      label: '商品名称',
      prop: 'name',
      header: 'name'
    }, {
      label: '商品金额',
      prop: 'price'
    }, {
      label: '币种',
      prop: 'currency',
      slot: 'currency'
    }, {
      label: '商品描述',
      prop: 'desc'
    }, {
      label: '操作',
      action: true,
      width: 150
    }];
    const editGoodsFormRef = ref();
    const currencyOptions = ref([]);
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const emits = __emit;
    const editGoodsForm = ref({
      goods: '',
      name: '',
      price: '',
      currency: '',
      desc: ''
    });
    const editGoodsFormRules = reactive({
      name: {
        required: true,
        message: '请输入商品名称',
        trigger: 'blur'
      },
      price: {
        required: true,
        message: '请输入商品金额',
        trigger: 'blur'
      },
      currency: {
        required: true,
        message: '请输入币种',
        trigger: 'blur'
      },
      desc: {
        required: true,
        message: '请输入商品描述',
        trigger: 'blur'
      }
    });
    const getTableData = async () => {
      const res = await apiUsdkGoodsList({
        gid: gameInfo.value.Id,
        Page: current.value,
        PageSize: pageSize.value
      });
      if (res.code === 0) {
        tableData.value = res.data;
        total.value = res.pageTotal;
      }
    };
    const handleConfirm = () => {
      editGoodsFormRef.value && editGoodsFormRef.value.validate(valid => {
        if (valid) {
          apiUsdkUpdateGoods({
            ...editGoodsForm.value,
            gid: gameInfo.value.Id
          }).then(res => {
            if (res.code === 0) {
              emits('onActive', 'goodsConf');
            }
          });
        }
      });
    };
    const handleClick = (type, data) => {
      if (type === 'edit') {
        emits('onActive', 'editGoods');
        editGoodsForm.value = data;
      }
      if (type === 'delete') {
        ElMessageBox.confirm(`是否确认删除【${data.name}】?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiUsdkDelGoods({
            id: data.id
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('');
        });
      }
    };
    const getCurrencyList = async () => {
      const res = await apiUsdkGetCurrencyList();
      if (res.code === 0) {
        currencyOptions.value = res.data;
      }
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
        getCurrencyList();
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.active, val => {
      console.log('=goodsConf', val);
      if (val === 'goodsConf') {
        getTableData();
      }
    }, {
      immediate: true
    });
    __expose({
      handleConfirm,
      getTableData
    });
    return (_ctx, _cache) => {
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_button = __unplugin_components_0;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card_pane, {
        name: "goodsConf"
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange),
          height: __props.height
        }, {
          goods: _withCtx(() => [_hoisted_1, _createVNode(_component_u_question, null, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          name: _withCtx(() => [_hoisted_3, _createVNode(_component_u_question, null, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })]),
          currency: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(scope.row.currency === 'RMB' ? 'CNY' : scope.row.currency), 1)]),
          action: _withCtx(({
            scope
          }) => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleClick('edit', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "danger",
            onClick: $event => handleClick('delete', scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange", "height"])]),
        _: 1
      }), _createVNode(_component_u_card_pane, {
        name: "editGoods"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "editGoodsFormRef",
          ref: editGoodsFormRef,
          model: _unref(editGoodsForm),
          rules: _unref(editGoodsFormRules),
          "label-width": "120px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品ID",
            prop: "goods"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editGoodsForm).goods,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(editGoodsForm).goods = $event),
              disabled: "",
              style: {
                "width": "300px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editGoodsForm).name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(editGoodsForm).name = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品金额",
            prop: "price"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editGoodsForm).price,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(editGoodsForm).price = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "币种",
            prop: "currency"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(editGoodsForm).currency,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(editGoodsForm).currency = $event),
              style: {
                "width": "300px"
              },
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOptions), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.currency,
                  label: item.desc,
                  value: item.currency
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品描述",
            prop: "desc"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(editGoodsForm).desc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(editGoodsForm).desc = $event),
              style: {
                "width": "300px"
              },
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      })], 64);
    };
  }
});